import { useMemo } from 'react';
import { BrandingProductType } from 'vopay';
import type { BrandingHostProps } from 'shared/branding';
import { useLockedFeatures } from '@/providers/LockedFeatures.provider';
import { useBranding } from '@/providers/Branding.provider';

export default function useBrandingHostProps(): BrandingHostProps {
  const { BrandingEmailEnabled, BrandingELinxEnabled, BrandingPortalEnabled } = useLockedFeatures();
  const { setBrandingValues, defaultPrimaryColor, defaultSecondaryColor } = useBranding();

  const products = useMemo(
    () =>
      [
        { productType: BrandingProductType.Portal, enabled: BrandingPortalEnabled },
        { productType: BrandingProductType.Elinx, enabled: BrandingELinxEnabled },
        { productType: BrandingProductType.Email, enabled: BrandingEmailEnabled },
      ]
        .filter((option) => option.enabled)
        .map((option) => option.productType),
    [BrandingPortalEnabled, BrandingELinxEnabled, BrandingEmailEnabled],
  );

  const defaultColors = useMemo(
    () => ({ primary: defaultPrimaryColor, secondary: defaultSecondaryColor }),
    [defaultPrimaryColor, defaultSecondaryColor],
  );

  return {
    products,
    defaultColors,
    onPortalBrandingSaved: (branding) =>
      setBrandingValues({
        primaryColor: branding.BrandingDetails?.PrimaryColor || defaultPrimaryColor,
        secondaryColor: branding.BrandingDetails?.SecondaryColor || defaultSecondaryColor,
        logo: branding.Logo,
        smallLogo: branding.SmallLogo,
        appTitle: branding.AppTitle,
        appFavicon: branding.Favicon,
      }),
  };
}
